import { ScreenAuthSignUp } from '@dms/screen'

export default ScreenAuthSignUp
